import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

export type ResizeWatcher = {
  width: number;
  height: number;
};

@Directive({
  selector: '[appResizeWatcher]',
  standalone: false,
})
export class ResizeWatcherDirective implements AfterViewInit, OnDestroy {
  @Input() set appResizeWatcherActive(isActive: boolean | undefined) {
    this.isActive = Boolean(isActive);
    this.checkAndStartObserving();
  }
  @Input() excludeBorders = false;

  @Output() sizeChanged = new EventEmitter<ResizeWatcher>();

  private isActive = true;
  private viewInitialized = false;
  private isObserving = false;
  private resizeObserver!: ResizeObserver;

  constructor(private readonly elRef: ElementRef) {}

  ngAfterViewInit() {
    this.viewInitialized = true;
    this.checkAndStartObserving();
  }

  ngOnDestroy() {
    this.stopObserving();
  }

  private checkAndStartObserving(): void {
    if (this.viewInitialized && this.isActive && !this.isObserving) {
      this.startObserving();
    } else if (!this.isActive && this.isObserving) {
      this.stopObserving();
    }
  }

  private startObserving(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const target = entry.target as HTMLElement;
        const rect = target.getBoundingClientRect();
        let borderLeft;
        let borderRight;
        let borderTop;
        let borderBottom;
        if (this.excludeBorders) {
          const styles = window.getComputedStyle(target);
          borderLeft = parseFloat(styles.borderLeftWidth);
          borderRight = parseFloat(styles.borderRightWidth);
          borderTop = parseFloat(styles.borderTopWidth);
          borderBottom = parseFloat(styles.borderBottomWidth);
        }
        const width = Math.round(rect.width - (this.excludeBorders ? (borderLeft + borderRight) : 0));
        const height = Math.round(rect.height) - (this.excludeBorders ? (borderTop + borderBottom) : 0);
        this.sizeChanged.emit({ width, height });
      }
    });

    this.resizeObserver.observe(this.elRef.nativeElement);
    this.isObserving = true;
  }

  private stopObserving(): void {
    if (!this.resizeObserver) {
      return;
    }
    this.resizeObserver.disconnect();
    this.isObserving = false;
  }
}
